export default "__VITE_ASSET__DVUDj6fY__"